<template>
  <table
    class="table is-fullwidth is-bordered is-striped is-narrow"
    style="font-variant-caps: all-petite-caps;"
  >
    <tbody>
      <tr>
        <td class="title-cell"></td>
        <td>JAN</td>
        <td>FEB</td>
        <td>MAR</td>
        <td>APR</td>
        <td>MAY</td>
        <td>JUN</td>
        <td>JUL</td>
        <td>AUG</td>
        <td>SEP</td>
        <td>OCT</td>
        <td>NOV</td>
        <td>DEC</td>
      </tr>
      <tr v-for="(row, idx) in rows" v-bind:key="'row' + idx">
        <td class="title-cell">{{ row.year }}</td>
        <td v-for="(column, dx) in row.columns" v-bind:key="'column' + dx">{{column && column.status ? column.status : ''}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from "moment";
export default {
  name: "ExpPaymentHistory",
  components: {},
  props: {
    history: String,
    balanceDate: String
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      months: [],
      rows: []
    };
  },
  methods: {},
  mounted: function() {
    let years = {};
    let history_index = 0;
    let d = moment(this.balanceDate, "MMDDYYYY");
    years[d.format("YYYY")] = 1;
    let modifiable = moment(d);
    this.months.push({
      moment: modifiable,
      monthNum: modifiable.format("M"),
      year: modifiable.format('YYYY'),
      status: this.history.charAt(history_index)
    });
    for (var i = 0; i < 25; i -= -1) {
      var m = moment(modifiable.subtract(1, "months"));
      history_index++
      years[m.format("YYYY")] = 1;
      this.months.push({
        moment: m,
        monthNum: m.format("M"),
        year: m.format('YYYY'),
        status: this.history.charAt(history_index)
      });
    }
    for (var year in years) {
      console.log(year);
      this.rows.push({ year: year, columns: new Array(12) });
    }
    let self = this
    this.months.forEach((month) => {
      self.rows.forEach((row) => {
        if (month.year == row.year){
          row.columns[month.monthNum - 1] = {status: month.status}
        }
      })
    })
    this.rows = this.rows.reverse();
    this.startDate = d;
    console.log(d);
  }
};
</script>
